module.exports = __webpack_public_path__ + "media/GCC/8. Banner - Contactos-46accafe.png";